export var LoginTypesEnum;
(function (LoginTypesEnum) {
    LoginTypesEnum[LoginTypesEnum["Wallet"] = 1] = "Wallet";
    LoginTypesEnum[LoginTypesEnum["Email"] = 2] = "Email";
    LoginTypesEnum[LoginTypesEnum["Google"] = 3] = "Google";
    LoginTypesEnum[LoginTypesEnum["Facebook"] = 4] = "Facebook";
    LoginTypesEnum[LoginTypesEnum["Instagram"] = 5] = "Instagram";
    LoginTypesEnum[LoginTypesEnum["Discord"] = 6] = "Discord";
    LoginTypesEnum[LoginTypesEnum["Telegram"] = 7] = "Telegram";
    LoginTypesEnum[LoginTypesEnum["Twitter"] = 8] = "Twitter";
    LoginTypesEnum[LoginTypesEnum["Spotify"] = 9] = "Spotify";
})(LoginTypesEnum || (LoginTypesEnum = {}));
export const siweMessage = "Welcome to dripit. Signing is the only way we can truly know that you are the owner of the wallet you are connecting. Signing is a safe, gas-less transaction that does not in any way give dripit permission to perform any transactions with your wallet.";
//# sourceMappingURL=login.constants.js.map